import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class AuthErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, isAuthError: false };
  }

  static getDerivedStateFromError(error) {
    // Don't set hasError here - wait for componentDidCatch to determine if it's auth-related
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error('AuthErrorBoundary caught an error:', error, errorInfo);
    
    // Check if it's an auth-related error
    const isAuthError = this.isAuthError(error);
    
    if (isAuthError) {
      this.setState({ hasError: true, error, isAuthError: true });
    } else {
      // For non-auth errors, just log them but don't redirect
      console.warn('Non-auth error caught, not redirecting:', error);
      this.setState({ hasError: false, error, isAuthError: false });
    }
  }

  isAuthError(error) {
    if (!error) return false;
    
    // Check if it's an auth-related error
    return (
      error.message?.includes('auth') || 
      error.message?.includes('permission') || 
      error.message?.includes('unauthenticated') ||
      error.message?.includes('unauthorized') ||
      error.code === 'auth/user-not-found' ||
      error.code === 'auth/user-disabled' ||
      error.code === 'auth/invalid-credential' ||
      error.code === 'auth/operation-not-allowed' ||
      error.code === 'auth/too-many-requests' ||
      error.code === 'auth/network-request-failed' ||
      error.code === 'auth/requires-recent-login'
    );
  }

  render() {
    if (this.state.hasError && this.state.isAuthError) {
      // Only redirect for actual auth errors
      console.log('Redirecting to login due to auth error:', this.state.error);
      return <Navigate to="/login" replace />;
    }

    // For non-auth errors or no errors, just render children normally
    return this.props.children;
  }
}

export default AuthErrorBoundary;
